import React, { useState } from 'react';
import {
  Modal,
  View,
  TouchableWithoutFeedback,
  Linking,
  Platform,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {
  Description,
  HowItWorksTitle,
  Container,
  ModalOverlay,
  ModalContent,
  Header,
  HeaderTitle,
  CloseButton,
  CloseButtonText,
  List,
  Bold,
  ThumbImage,
  ThumbButton,
  ModalBody,
  Footer,
} from './styles';
import {Titles} from '../../Interface/Typographies/Titles';
import {StepList} from '../../Interface/List/StepList';
import {Button} from '../../Interface/Forms/Buttons/Button';

import thumbImage from '../../../assets/images/banners/thumb-avalie.webp'
import { HelpVideo } from '../HelpVideo';
import { useTheme } from 'styled-components';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AvalieGanheBottomSheet({isOpen, onClose}: Props) {
  const [showVideo, setShowVideo] = useState(false);
  const theme = useTheme();
  return (
    <Modal visible={isOpen} onRequestClose={onClose} transparent animationType='fade'> 
      <ModalOverlay>
        <TouchableWithoutFeedback onPress={onClose}>
          <View
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />
        </TouchableWithoutFeedback>
        <ModalContent>
                
            <Container>
              
              <ThumbButton activeOpacity={0.7} onPress={() => setShowVideo(true)} >
                
                <ThumbImage source={thumbImage} resizeMode="cover">
                  <Header>
                 
              <CloseButton onPress={onClose}>
                <CloseButtonText>✕</CloseButtonText>
              </CloseButton>
              </Header>
                  <HeaderTitle>Opine e Ganhe</HeaderTitle>
                  </ThumbImage>
              </ThumbButton>

<ModalBody>

              <Titles

                title="Sua opinião vale economia de verdade!"
              />
              <Description>
                Deixe sua avaliação 5 estrelas e um comentário positivo sobre o
                Baratão na App Store ou Play Store. Em até um dia útil,{' '}
                <Bold>
                  responderemos seu comentário com um cupom de desconto
                  exclusivo{' '}
                </Bold>
                para você usar no seu próximo abastecimento. Participe!
              </Description>

              <HowItWorksTitle>Como funciona?</HowItWorksTitle>

              <List>
                <StepList
                  number={1}
                  text="Acesse a App Store ou Play Store, dê 5 estrelas e descreva o que você mais adora no Baratão!"
                />
                <StepList
                  number={2}
                  text="Fique de olho! Nossa equipe responderá sua avaliação com um código de cupom exclusivo em até um dia útil."
                />
                <StepList
                  number={3}
                  text="Copie o código da resposta, use-o no app Baratão e turbine sua economia no próximo abastecimento!"
                />
              </List>

             
</ModalBody>
              
            </Container>

            <Footer>
               <Button
                title="AVALIE AGORA!"
                onPress={() =>
                  Platform.OS === 'ios'
                    ? Linking.openURL(
                        'https://apps.apple.com/br/app/barat%C3%A3o-combust%C3%ADveis/id1613535824?l=en',
                      )
                    : Linking.openURL(
                        'https://play.google.com/store/apps/details?id=com.barataoapp&hl=pt_PT&gl=US',
                      )
                }
                enabled
              />
            </Footer>
           
        </ModalContent>

      </ModalOverlay>
      {
        showVideo && (<HelpVideo videoURI='https://d3ag5cip9ldvh3.cloudfront.net/AVALIEGANHE.MP4' onVideoEnd={() => setShowVideo(false)}/>)
      }
    </Modal>
  );
}
